export const buttonText = {
  send: 'Send',
  verify: 'Verify'
};
